import { render, staticRenderFns } from "./ProductCategories.vue?vue&type=template&id=67244252&scoped=true"
import script from "./ProductCategories.vue?vue&type=script&lang=js"
export * from "./ProductCategories.vue?vue&type=script&lang=js"
import style0 from "./ProductCategories.vue?vue&type=style&index=0&id=67244252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67244252",
  null
  
)

export default component.exports